export default {
  name: "Red Stripe",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/logo-color.webp`,
  products: [
    {
      id: "redstripe",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/en/product_forward_redstripe.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/fr/product_forward_redstripe.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "A beautiful amber lager with low butterscotch flavour, full bodied and a smooth post palate sensation. Lager beer, light gold colour.",
        fr: "Une belle bière blonde ambrée au goût subtil de caramel au beurre, ample et avec une douce sensation en finale. Une bière lager, de couleur dorée claire.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/en/information_render_bottle_330ml_redstripe.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/fr/information_render_bottle_330ml_redstripe.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/en/information_nft_bottle_330_redstripe.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/redstripe/fr/information_nft_bottle_330_redstripe_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
      ],
    },
  ],
};
